var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-view',[_c('template',{slot:"status"},[_vm._v(_vm._s(_vm.$t('Subscription')))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }